import { render, staticRenderFns } from "./appStoreCard.vue?vue&type=template&id=9ae82a10&scoped=true&"
import script from "./appStoreCard.vue?vue&type=script&lang=js&"
export * from "./appStoreCard.vue?vue&type=script&lang=js&"
import style0 from "./appStoreCard.vue?vue&type=style&index=0&id=9ae82a10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ae82a10",
  null
  
)

export default component.exports